/**
 * @file use-permission.js
 * @description User permissions hook
 * @version 0.0.1
 * Created at: 01/09/2025
 * Updated at: 01/09/2025
 */
import { useContext } from 'react';

import { PermissionContext } from '@/provider';

export const usePermissions = () => useContext(PermissionContext);
